<template>
    <div>
        <el-form size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item :label="$t('reports.from')"
                                  prop="dateFrom">
                        <el-date-picker v-model="form.dateFrom"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.serviceTicketNum')"
                                  prop="serviceTicketId">
                        <el-input v-model="form.serviceTicketId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$t('reports.to')"
                                  prop="dateTo">
                        <el-date-picker v-model="form.dateTo"
                                        type="date"
                                        style="width:100%;"></el-date-picker>
                    </el-form-item>

                    <el-form-item :label="$t('common.invoiceNumber')"
                                  prop="invoiceNumber">
                        <el-input v-model="form.invoiceNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-checkbox-group v-model="form.fields"
                               ref="group"
                               class="fields">
                <el-row>
                    <el-col :span="12">
                        <el-checkbox class="checkbox"
                                     label="1">{{$t('common.rmaNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="2">{{$t('common.shippingMethod')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="3">{{$t('common.serviceCompany')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="4">{{$t('common.serviceTicketNum')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="5">{{$t('reports.attn')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="6">{{$t('reports.rmaStatus')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="7">{{$t('common.trackingNumber')}}</el-checkbox>

                    </el-col>
                    <el-col :span="12">

                        <el-checkbox class="checkbox"
                                     label="8">{{$t('reports.countryOfOrigin')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="9">{{$t('common.claimNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="10">{{$t('common.invoiceNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="11">{{$t('common.customerName')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="12">{{$t('common.rmaCreationDate')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="13">{{$t('reports.authorizationNumber')}}</el-checkbox>
                        <el-checkbox class="checkbox"
                                     label="14">{{$t('reports.modelNumber')}}</el-checkbox>

                    </el-col>
                </el-row>
            </el-checkbox-group>
            <el-button @click="selectAll">{{$t('common.deSelectAll')}}</el-button>
            <el-button :loading="loading"
                       type="primary"
                       @click="generateReport">{{$t('common.generate')}}</el-button>
            <p class="labelInfo" ref="labelInfo" v-if="this.form.fields.length == 0">{{$t('reports.pleaseSelectatLeastOneColumn')}}</p>
            <p class="labelInfo">{{$t('reports.noDatesChoosenMessage')}}</p>
        </el-form>
    </div>
</template>

<script>
    import Vue from "vue";
    import api from "../api";

    export default {
        name: "rma",
        components: {

        },
        props: {

        },
        data() {
            return {
                form: {
                    fields: []
                },
                loading: false
            };
        },
        methods: {
            selectAll() {
                if (this.form.fields.length === 14) {
                    this.form.fields = [];
                } else {
                    for (var i = 1; i <= 14; i++) {
                        this.form.fields.push(i + "");
                    }
                }
            },
            generateReport() {
                if (this.form.fields.length == 0) {
                    this.$refs["labelInfo"].focus();
                    return;
                }
                this.loading = true;
                api.downloadRmaReport(this.form).then(response => {
                    this.loading = false;
                    var blob = response.data;
                    var fileName = response.headers["content-disposition"]
                        .split(";")[1]
                        .split("=")[1];
                    fileName = fileName.replace(/"/g, '')
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var blobURL = window.URL.createObjectURL(blob);
                        var tempLink = document.createElement("a");
                        tempLink.style.display = "none";
                        tempLink.href = blobURL;
                        tempLink.setAttribute("download", fileName);

                        // Safari thinks _blank anchor are pop ups. We only want to set _blank
                        // target if the browser does not support the HTML5 download attribute.
                        // This allows you to download files in desktop safari if pop up blocking
                        // is enabled.
                        if (typeof tempLink.download === "undefined") {
                            tempLink.setAttribute("target", "_blank");
                        }

                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }
                });
            }
        },
        computed: {

        },
        watch: {

        }
    };
</script>

<style scoped>
    .checkbox {
        width: 100%;
        margin-left: 0;
    }

    .fields {
        width: 570px;
        margin-bottom: 10px;
    }

    .labelInfo {
        font-size: smaller;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/RMA.vue